import { render } from "./PvpAuthLoginPage.vue?vue&type=template&id=2d5deb50"
import script from "./PvpAuthLoginPage.vue?vue&type=script&lang=ts"
export * from "./PvpAuthLoginPage.vue?vue&type=script&lang=ts"

import "./PvpAuthLoginPage.vue?vue&type=style&index=0&id=2d5deb50&lang=scss"
script.render = render

export default script